import { Field as FormField } from '../../../libs/gs-component-form';
import { Content } from '../../../libs/gs-component-right-rail';
import { RadioButton, SingleSelectGroup } from '@xo-union/tk-component-switches';
import { Body1, Caption, H3 } from '@xo-union/tk-ui-typography';
import { Field as FormikField, FieldProps } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { SharedFormProps } from '../../../helpers/useManageItem';
import { Footer } from '../../FormComponents';
import { DeleteOrDiscard } from '../DeleteOrDiscard';
import styles from './index.scss';
import { HeadlineItemsFragment, Maybe } from '../../../generated/graphql';
import { useAiTextExperimentContext } from '../../../context/AiTextExperimentContext';

export const validationSchema = Yup.object().shape({
  style: Yup.string()
    .required()
    .oneOf(['small', 'large']),
  title: Yup.string()
    // eslint-disable-next-line
    .max(255, 'Title must be less than ${max} characters')
    .required('Headline Text cannot be blank'),
});

export interface InitialValues {
  title?: string | null;
  style?: string | null;
}

export const initialValues = (item?: Maybe<HeadlineItemsFragment>): InitialValues => ({
  title: item?.title || '',
  style: item?.style || 'small',
});

const Form: React.FC<SharedFormProps> = ({
  loading,
  updating,
  submitForm,
  setFieldValue,
  isNew,
  discardOrDelete,
  close,
}) => {
  const { showAiButton } = useAiTextExperimentContext();
  return (
    <>
      <Content className={styles.content} loading={loading}>
        <Caption className={styles.caption}>Title Type</Caption>
        <FormikField name="style">
          {({ field: { value } }: FieldProps) => (
            <SingleSelectGroup
              value={value}
              onChange={(evt: React.FormEvent<HTMLInputElement>): void => {
                setFieldValue('style', evt.currentTarget.value);
              }}
            >
              <RadioButton value="small" data-testid="smallradio">
                <Body1>Small Title</Body1>
              </RadioButton>
              <RadioButton value="large" data-testid="largeradio">
                <H3 as="body1">Large Title</H3>
              </RadioButton>
            </SingleSelectGroup>
          )}
        </FormikField>

        <FormikField
          component={FormField}
          showAiButton={showAiButton}
          name="title"
          label="Title Text"
          data-testid="textfield"
        />
        <div className={styles.removeContainer}>
          <DeleteOrDiscard onClick={discardOrDelete} isNew={isNew}>
            Delete title
          </DeleteOrDiscard>
        </div>
      </Content>
      <Footer primaryOnClick={submitForm} showSpinner={updating} useSaveAndPreview={true} secondaryOnClick={close} />
    </>
  );
};

export default Form;
